export default [
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/history/History.vue'),
  },
]
